export default {
    infomationTip: '免责声明：以上内容仅供参考，不作为投资决策依据。投资有风险，入市需谨慎。',
    infomationThirdTip:
        '免责声明：以上信息及数据来源自第三方，平台无法核实信息的真实性、准确性、完整性及原创性等。星财富转载仅供投资者参考，并不代表复星国际证券有限公司及其控股或附属公司的观点，不构成任何投资建议，您自己承担因信赖或只用第三方信息而导致的任何损失。投资有风险，入市需谨慎。',
    infomationStarWealthTip: '免责声明：本内容由复星财富国际控股有限公司全资子公司复星国际证券有限公司基于人工智能分析整合后生成，数据来源为互联网公开信息。复星财富国际控股有限公司及其全资子公司复星国际证券有限公司及/或其关联公司将竭力但却不能保证以上内容之准确和可靠，亦不会承担因任何不准确或遗漏而引起的任何损失或损害。本文内容仅供参考，不作为实际操作建议，也不构成及不应被视为买卖任何证券或投资的要约或该要约的招徕或恳求。投资者应自行核实相关信息并独立判断，所有交易决策需结合个人风险承受能力，市场有风险，投资需谨慎，过往表现不预示未来结果。<br/><br/>免责声明：以上内容仅供参考，不作为投资决策依据。投资有风险，入市需谨慎。',
    infomationStock: '相关标的',
    infomationNews: '相关资讯',
    informationTitle: '资讯详情',
    flashNews: '快讯',
    newwork: '网络连接超时，请稍后重试',
    text01: '伴您财富乘长 ',
    text02: '很抱歉，您查看的内容不存在',
    downloadMsg: '下载',
    openAppMsg: 'APP内打开',
    reading: '阅读',
    readingNum: '阅读量',
    disclaimer: '以上信息及数据来源自第三方，本平台无法核实信息的真实性、准确性、完整性及原创性等。以上转载内容仅供参考，不作为本平台之立场及投资决策依据。投资有风险，入市需谨慎。',
    disclaimer4AI: '本内容由本平台基于人工智能分析整合后生成，数据来源为互联网公开信息。本平台竭力但不能保证上述内容准确和可靠。以上内容仅供参考，不作为投资决策依据。投资有风险，入市需谨慎。',
    night: '夜盘',
    minutesAgo: '{n}分钟前',
    loading: '加载中...'
}
